<div class="modal">
  <button class="close-btn btn" (click)="closeModal()">
    <svg class="icon">
      <use xlink:href="#large-cross"></use>
    </svg>
  </button>

  <div class="head">
    <h3 class="title">{{ isNewAccount ? 'Add Email account' : 'Edit Email account' }}</h3>

    <p class="subtitle">
      {{ isNewAccount ? 'Set your email account settings' : 'Edit your email account settings' }}
    </p>
  </div>

  <div class="content-wrapper">
    <app-scrollbar class="scrollbar" [vertical]="true" [size]="'standard'" [visibility]="'native'">
      <app-email-account-settings
        #accountSettings
        class="content"
        (validStateUpdate)="validStateChange($event)"></app-email-account-settings>
    </app-scrollbar>
  </div>

  <div class="actions">
    <button class="link new-link--back" (click)="closeModal()">Cancel</button>

    <button
      class="btn btn--new-primary bright save-btn"
      disabled="true"
      [disabled]="$saveIsDisabled | async"
      (click)="save()">
      <span class="btn__text">Save</span>
    </button>
  </div>
</div>
